import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { clsx as x } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as R } from "../../style/base/index.js";
import { useEscapeKey as b } from "../../utils/use-escape-key.js";
import { useFloatingTooltip as g } from "../../utils/use-floating-tooltip.js";
import { RocheUIIcon as v } from "../icon/roche-icon.js";
import { RocheUITooltipContent as y } from "../tooltip-content/roche-tooltip-content.js";
import n from "./roche-tooltip.module.scss.js";
const C = 18, L = ({ children: i, height: l = C, ariaLabel: s }) => {
  const { refs: r, floatingStyles: c, arrowRef: a, context: m, open: e, setOpen: o } = g({ placement: "bottom" });
  b(() => o(!1), e);
  const p = () => o((h) => !h), f = () => o(!0), u = () => o(!1);
  return /* @__PURE__ */ d("div", { className: n.tooltip, children: [
    /* @__PURE__ */ t(
      "button",
      {
        ref: r.setReference,
        type: "button",
        className: x(n.tooltip__icon, e && n["tooltip__icon--active"]),
        "aria-label": s,
        onClick: p,
        onMouseEnter: f,
        onMouseLeave: u,
        onBlur: () => o(!1),
        children: /* @__PURE__ */ t(v, { icon: "info", height: `${R(l)}rem` })
      }
    ),
    /* @__PURE__ */ t(
      y,
      {
        floatingStyles: c,
        arrowRef: a,
        open: e,
        context: m,
        refs: r,
        children: i
      }
    )
  ] });
};
export {
  L as RocheUITooltip
};
